import React from "react";

/**
 * Ad placeholder — replace the inner div with your Google AdSense code when approved.
 * Example: <ins className="adsbygoogle" ... />
 */
const AdSlot = ({ size = "banner", className = "" }) => {
  const sizes = {
    banner: "min-h-[90px] md:min-h-[120px]",
    rectangle: "min-h-[250px]",
    sidebar: "min-h-[600px] w-full max-w-[300px]",
  };

  return (
    <div
      className={`ad-slot ${sizes[size] || sizes.banner} ${className}`}
      aria-label="Advertisement"
    >
      <div className="h-full w-full glass-panel flex flex-col items-center justify-center border-dashed border-white/10 text-center px-4">
        <span className="text-[10px] uppercase tracking-widest text-gray-600 mb-1">
          Advertisement
        </span>
        <span className="text-xs text-gray-600">
          Ad space — connect Google AdSense here
        </span>
      </div>
    </div>
  );
};

export default AdSlot;
